import React, { useState } from "react";
// import PageTitle from "../../components/shared/PageTitle";
import PageHeadline from "../../components/shared/PageHeadline";
import { useTranslation } from "react-i18next";
// import axios from "axios";

export default function Index() {
    const { t } = useTranslation();
    const [isSuccess, setSuccess] = useState(false);
    const [isError, setError] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const MAIL_SENDER_URL = "https://bandoeng10k-mailer.vercel.app/api/email";
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        subject: "",
        message: "",
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        await fetch(
            MAIL_SENDER_URL,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
                mode: 'no-cors',
            },
        ).then((res) => {
            setFormData({
                name: "",
                email: "",
                phone: "",
                subject: "",
                message: "",
            });
            setSuccess(true);
            setTimeout(() => {
                setSuccess(false);
            }, 5000);
        })
            .catch(() => {
                setSuccess(false);
                setError(true);
            })
            .finally(() => {
                setLoading(false);
            }
            );
    };

    return (
        <div className="text-brand-blue md:px-0 px-4 bg-white">
            <div className="relative min-h-[240px] lg:min-h-[300px] bg-brand-blue bg-contain md:bg-cover bg-no-repeat top-[86px] md:top-[109px] 2xl:top-[136px] flex justify-center items-center">
                <PageHeadline title={t("contact.title")} />
            </div>
            {/* <ComingSoonBanner /> */}
            <div className="top-12 md:top-40 lg:top-60 relative bg-white  2xl:px-0 md:px-14 px-0 py-5 pb-96">
                <div className="bg-white min-h-screen container mx-auto px-4 w-full font-poppins text-brand-blue">
                    {isSuccess && (
                        <div className="w-full bg-sky-200 p-4 mb-10 text-sky-800 rounded-lg">
                            <h1>
                                {t("contact.successMessage")}
                            </h1>
                        </div>
                    )}

                    {isError && (
                        <div className="w-full bg-red-200 p-4 mb-10 text-red-800 rounded-lg">
                            <h1>{t("contact.failedMessage")}</h1>
                        </div>
                    )}
                    <div className="flex items-center justify-start h-full">
                        <form className="w-full space-y-8" onSubmit={handleSubmit}>
                            <div className="space-y-6">
                                <label htmlFor="subject" className="!font-poppins">{t("contact.subject")}</label>
                                <input
                                    id="subject"
                                    name="subject"
                                    type="text"
                                    value={formData.subject}
                                    onChange={handleChange}
                                    className="bg-brand-blue block border shadow-2xl w-full 2xl:py-6 2xl:px-6 p-4 rounded-lg placeholder:text-neutral-300 text-white"
                                    placeholder={t("contact.subject")}
                                    required
                                />
                            </div>
                            <div className="space-y-6">
                                <label htmlFor="name" className="!font-poppins">{t("contact.name")}</label>
                                <input
                                    id="name"
                                    name="name"
                                    type="text"
                                    value={formData.name}
                                    onChange={handleChange}
                                    className="bg-brand-blue block border shadow-2xl w-full 2xl:py-6 2xl:px-6 p-4 rounded-lg placeholder:text-neutral-300 text-white"
                                    placeholder={t("contact.name")}
                                    required
                                />
                            </div>
                            <div className="space-y-6">
                                <label htmlFor="email" className="!font-poppins">{t("contact.email")}</label>
                                <input
                                    id="email"
                                    name="email"
                                    type="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    className="bg-brand-blue block border shadow-2xl w-full 2xl:py-6 2xl:px-6 p-4 rounded-lg placeholder:text-neutral-300 text-white"
                                    placeholder="email@mail.com"
                                    required
                                />
                            </div>
                            {/* <div className="inline-flex w-full space-x-10">
                                <div className="w-1/2 space-y-6">
                                    <label htmlFor="email" className="!font-poppins">{t("contact.email")}</label>
                                    <input
                                        id="email"
                                        name="email"
                                        type="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        className="bg-brand-blue block border shadow-2xl w-full 2xl:py-6 2xl:px-6 p-4 rounded-lg placeholder:text-neutral-300 text-white"
                                        placeholder="email@mail.com"
                                        required
                                    />
                                </div>
                                <div className="w-1/2 space-y-6">
                                    <label htmlFor="phone" className="!font-poppins">{t("contact.phone")}</label>
                                    <input
                                        id="phone"
                                        name="phone"
                                        type="number"
                                        value={formData.phone}
                                        onChange={handleChange}
                                        className="bg-brand-blue block border shadow-2xl w-full 2xl:py-6 2xl:px-6 p-4 rounded-lg placeholder:text-neutral-300 text-white"
                                        placeholder="628512345678"
                                        required
                                    />
                                </div>
                            </div> */}
                            <div className="space-y-6">
                                <label htmlFor="message" className="!font-poppins">{t("contact.message")}</label>
                                <textarea
                                    rows={10}
                                    id="message"
                                    name="message"
                                    value={formData.message}
                                    onChange={handleChange}
                                    className="bg-brand-blue block border shadow-2xl w-full 2xl:py-6 2xl:px-6 p-4 rounded-lg placeholder:text-neutral-300 text-white"
                                    placeholder={t("contact.messagePlaceholder")}
                                    required
                                ></textarea>
                            </div>
                            <button
                                type="submit"
                                disabled={isLoading}
                                className="w-full bg-brand-orange py-4 rounded-lg shadow-2xl uppercase font-bold"
                            >
                                {t("contact.send")}
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}
